import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ResidentModel } from '@shared/models/data/resident-model';
import { AuthService } from '@shared/services/auth.service';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';
import { EditResidentComponent as EditResidentDialogComponent } from '../edit-resident/edit-resident.component';
import { ResidentRemoveDialogComponent } from '../resident-remove-dialog/resident-remove-dialog.component';
import { ResidentSearchDialogComponent } from '../resident-search-dialog/resident-search-dialog.component';
import { ResidentTransitionDialogComponent } from '../resident-transition-dialog/resident-transition-dialog.component';

@Component({
  selector: 'aaos-roster-table',
  templateUrl: './roster-table.component.html',
  styleUrls: ['./roster-table.component.scss']
})
export class RosterTableComponent implements AfterViewInit {

  @ViewChild(MatSort) sort: MatSort;
  @Input() residents: ResidentModel[];
  selectedResident: ResidentModel;

  dataSource: MatTableDataSource<ResidentModel>;
  columnsToDisplay = ['residencyPostGraduateYear', 'firstName', 'lastName', 'id', 'institutionalEmail', 'residencyDates', 'npi', 'actions'];
  selectedYear: string;
  editPrivileges = false;
  loading = true;
  enrollmentPeriodActive = false;

  constructor(private enrollmentService: EnrollmentService,
    private authService: AuthService,
    private sessionService: SessionService,
    private dialog: MatDialog) {
    this.dataSource = new MatTableDataSource();
    this.enrollmentService.rosterChange.subscribe(() => {
      this.refresh();
    });
    this.editPrivileges = this.authService.changeAuthorized();
  }

  get residentCount() {
    return this.dataSource.filteredData?.length ?? 0;
  }

  trimLeadingZeros(stringToReplace: string) {
    return stringToReplace.replace(/^0+/, '');
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.refresh();
  }

  applyFilter(event) {
    const filterValue = this.selectedYear;
    this.dataSource.filterPredicate = (data: ResidentModel, filter: string) =>
      !filter || data.residencyPostGraduateYear.toString() === this.selectedYear.toString();
    this.dataSource.filter = filterValue;

  }

  public openRemoveResidentDialog(resident: ResidentModel) {
    this.selectedResident = resident;
    this.dialog.open(ResidentRemoveDialogComponent, this.getModalConfig());
  }

  public openEditResidentDialog(resident: ResidentModel) {
    this.selectedResident = resident;
    this.dialog.open(EditResidentDialogComponent, this.getModalConfig());
  }

  public openTransitionResidentDialog(resident: ResidentModel) {
    this.selectedResident = resident;
    this.dialog.open(ResidentTransitionDialogComponent, this.getModalConfig());
  }

  getModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.selectedResident,
    } as MatDialogConfig;
  }

  openSearchDialog() {
    const dialogRef = this.dialog.open(ResidentSearchDialogComponent, this.getModalConfig());

  }

  private refresh() {
    this.loading = true;
    this.enrollmentService.getRosterModel(this.sessionService.getInstitutionId()).subscribe(x => {
      this.residents = x.residents;
      this.enrollmentPeriodActive = x.enrollmentPeriodActive;
      this.dataSource.data = this.residents;
      this.loading = false;
    });
  }
}
